export class AttachmentRequest {
    fileName: string;
    key: string;
}
